<template>
    <TabHeader class="tab-links">
        <TabHeaderLink
            v-for="tab in tabs"
            :key="tab.link"
            :to="tab.link"
            :label="tab.label"
            :icon="tab.icon"
            :data-qa="tab.label"
        />
    </TabHeader>
</template>

<script>
import mitt from 'mitt';
import TabHeader from './TabHeader';
import TabHeaderLink from './TabHeaderLink';

export default {
    name: 'DsTabLinks',

    components: {
        TabHeader,
        TabHeaderLink,
    },

    provide() {
        return { emitter: this.emitter };
    },

    props: {
        /**
         * List of tabs to render. Tabs contain { link, label, exact } strings.
         */
        tabs: Array,

        /**
         * Set to true to exclusively match for active class.
         */
        exact: Boolean,
    },

    beforeCreate() {
        this.emitter = mitt();
    },

    beforeDestroy() {
        this.emitter.off('*');
    },

    watch: {
        tabs() {
            this.emitter.emit('TAB_HEADER_TABS_UPDATED');
        },
    },
};
</script>

<style lang="scss" scoped>
    .tab-links-link {
        color: inherit;

        &:hover {
            text-decoration: none;
        }
    }
</style>
